export const noop = () => {};

export const handleMock = (message: string) => () => {
  console.log(message);
};
